import { render, staticRenderFns } from "./PhonesView.vue?vue&type=template&id=44f72921&scoped=true&"
import script from "./PhonesView.vue?vue&type=script&lang=js&"
export * from "./PhonesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f72921",
  null
  
)

export default component.exports